// extracted by mini-css-extract-plugin
module.exports = {"cell":"NumberCell_cell"};